import { useAppSelector } from "../../app/hooks";
import { useIsEstablishmentManager } from "../../common/utils/useIsEstablishmentManager";
import { JSX } from "react";
import { EmployeeGeneralCreateForm } from "./employeeForms/EmployeeGeneralCreateForm";
import { EstablishmentManagerCreateFormAtQualification } from "./establishmentManagerForms/multipleStepsForm/EstablishmentManagerCreateFormAtQualification";
import { EmployeeCreateFormAtQualification } from "./employeeForms/EmployeeCreateFormAtQualification";
import { EstablishmentManagerGeneralCreateForm } from "./establishmentManagerForms/establishmentManagerGeneralForm/EstablishmentManagerGeneralCreateForm";
import { EstablishmentCertificateModal } from "./establishmentManagerForms/establishmentCertificateForm/EstablishmentCertificateModal";

export const CreateCertificateModalContainer = (): JSX.Element | null => {
    const { isAtQualification, isEstablishmentCertificate } = useAppSelector(
        (state) => state.createCertificateModal,
    );
    const isEstablishmentManager = useIsEstablishmentManager();

    switch (true) {
        case isEstablishmentManager &&
            isAtQualification &&
            isEstablishmentCertificate:
            return <EstablishmentCertificateModal />;
        case isEstablishmentManager && isAtQualification:
            return <EstablishmentManagerCreateFormAtQualification />;
        case isEstablishmentManager && !isAtQualification:
            return <EstablishmentManagerGeneralCreateForm />;
        case !isEstablishmentManager && isAtQualification:
            return <EmployeeCreateFormAtQualification />;
        case !isEstablishmentManager && !isAtQualification:
            return <EmployeeGeneralCreateForm />;
        default:
            return null;
    }
};
